import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { user, ready } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (ready && user) navigate(user.role === "admin" ? "/admin" : "/app", { replace: true });
  }, [ready, user, navigate]);

  const googleLogin = () => {
    const redirect = `${window.location.origin}/auth/callback`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col relative overflow-hidden">
      <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-blue-600/20 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-blue-500/10 blur-3xl" />

      <div className="flex-1 flex items-center justify-center px-5 py-10 safe-top safe-bottom relative z-10">
        <div className="w-full max-w-sm wp-fade-up">
          <div className="flex flex-col items-center mb-8">
            <img src="/omsivo-logo.png" alt="Omsivo EMP" className="h-20 w-20 rounded-full shadow-xl shadow-blue-600/30 mb-4" />
            <h1 className="text-3xl font-head font-extrabold text-white tracking-tight">Omsivo EMP</h1>
            <p className="text-slate-400 text-sm mt-1">Attendance & Salary Management</p>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-2xl space-y-5">
            <div className="text-center space-y-1">
              <h2 className="text-lg font-semibold text-slate-900">Sign in</h2>
              <p className="text-sm text-slate-500">Use your work Google account to continue</p>
            </div>

            <Button
              data-testid="google-signin-button"
              type="button"
              onClick={googleLogin}
              variant="outline"
              className="w-full h-12 text-base font-semibold border-slate-300 hover:bg-slate-50 gap-3"
            >
              <GoogleIcon /> Continue with Google
            </Button>

            <p className="text-xs text-slate-400 text-center leading-relaxed">
              Access is limited to registered staff. If your Google email isn't recognised, please contact your administrator.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg className="h-5 w-5" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.1 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z" />
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 18.9 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.1 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
      <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.5-4.6 2.4-7.2 2.4-5.2 0-9.6-3.3-11.2-8l-6.5 5C9.6 39.6 16.2 44 24 44z" />
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4.1 5.4l6.2 5.2C39.9 40.4 44 36 44 24c0-1.3-.1-2.3-.4-3.5z" />
    </svg>
  );
}
